/**
 * View Break block.
 * @module components/ItaliaTheme/Blocks/break/View
 */

import React from 'react';
import cx from 'classnames';

/**
 * View Break block class.
 * @class View
 * @extends Component
 */
const View = () => {
  return <div className={cx('block break-block')}></div>;
};

export default View;
